module.exports = __webpack_public_path__ + "static/media/direct.da595233.webp";